import Faqs from '../../views/Faqs';

export default function FAQsPage() {
  return <Faqs />;
}
